import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { INPUT_CLS, INPUT_ERROR_CLS } from 'helpers/formStyles';

/**
 * Input — canonical text input built on helpers/formStyles INPUT_CLS.
 * Works uncontrolled (react-hook-form `register`) or controlled.
 * For label + error scaffolding wrap it in <FormField>.
 */
const Input = React.forwardRef(({ error = false, className = '', ...rest }, ref) => (
  <input
    ref={ref}
    className={classNames(INPUT_CLS, error && INPUT_ERROR_CLS, className)}
    {...rest}
  />
));

Input.displayName = 'Input';

Input.propTypes = {
  error: PropTypes.bool,
  className: PropTypes.string
};

export default Input;
